// extracted by mini-css-extract-plugin
export default {"selectInputGroup":"styles_selectInputGroup__D7g2V","selectTriggerButton":"styles_selectTriggerButton__ngTw9"};